exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app-loading[data-v-36bc61fa]{position:fixed;top:0;left:0;width:100%;height:100%;background-color:#fff;z-index:1000}#app-loading[data-v-36bc61fa]:after{content:\"\";position:absolute;top:50%;left:50%;width:25px;height:25px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;border-color:rgba(0,0,0,0) #000;border-style:solid;border-width:2px;z-index:2;-webkit-animation:spin-loader .4s linear infinite;-moz-animation:spin-loader .4s linear infinite;-o-animation:spin-loader .4s linear infinite;animation:spin-loader .4s linear infinite}", ""]);

// exports
